export const environment = {
    production: true,
    apis: {
        public: 'https://api.netride.mx/api',
        base: 'https://api.netride.mx/api',
        socketUrl: 'http://94.72.126.113:4600'
    }
};
